import { prefixObjectValues } from '../../utils';
import basicInfoForm from './basic-info-form';
import compensationForm from './compensation-form';
import costCalculator from './cost-calculator';
import laborMetricsForm from './labor-metrics-form';
import reviewInfo from './review-info';
import shiftDetailsForm from './shift-details-form';
import table from './table';
import wizard from './wizard';

const PREFIX = 'msaas-listings';

export default {
  wizard: prefixObjectValues(wizard, PREFIX),
  basicInfoForm: prefixObjectValues(basicInfoForm, PREFIX),
  laborMetricsForm: prefixObjectValues(laborMetricsForm, PREFIX),
  compensationForm: prefixObjectValues(compensationForm, PREFIX),
  shiftDetailsForm: prefixObjectValues(shiftDetailsForm, PREFIX),
  costCalculator: prefixObjectValues(costCalculator, PREFIX),
  reviewInfo: prefixObjectValues(reviewInfo, PREFIX),
  table: prefixObjectValues(table, PREFIX),
};
